
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/auth/partnerships/achq",
      function () {
        return require("private-next-pages/docs/auth/partnerships/achq.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/auth/partnerships/achq"])
      });
    }
  